// extracted by mini-css-extract-plugin
export default {"root":"_3TJgs","collapsed":"_2r6YQ"};